import dayjs from 'dayjs'
import ThermalPrinterBase from '../../services/thermalPrinter/ThermalPrinterBase'
import { useFormatNumber } from '~/composables/useUtils'

type StockPrintRow = {
  name: string
  unit?: string
  category?: string
  begin: number
  add: number
  sold: number
  balance: number
}

type StockPrintGroup = {
  name: string
  rows: StockPrintRow[]
}

type StockPrintPayload = {
  storeName: string
  dateFrom: string
  dateTo: string
  lengthDays: number
  printAtShort?: string
  printAtLong?: string
  reportName?: string
  groups: StockPrintGroup[]
}

export default class ThermalPrintStock extends ThermalPrinterBase {
  printStockMovement(payload: StockPrintPayload) {
    this.print_data = this.withPayload(payload)
    return this
  }

  withPayload(payload: StockPrintPayload) {
    const now = dayjs()
    const shortTime = payload.printAtShort || `${now.format('HH:mm:ss')} @ ${now.format('DD/MM/YY')}`
    const longTime = payload.printAtLong || `${now.format('HH:mm:ss')} ${now.format('DD MMMM YYYY')}`
    const groups = Array.isArray(payload.groups) ? payload.groups : []

    const commands: any[] = [
      { name: 'PrintTitle', value: payload.storeName || '-' },
      { name: 'LineFeed', value: true },
      { name: 'Date from', value: payload.dateFrom || '-' },
      { name: 'Date to', value: payload.dateTo || '-' },
      { name: ' ', value: `length ${payload.lengthDays || 0} days` },
      { name: 'Print At', value: shortTime },
      { name: 'Report', value: payload.reportName || 'Inventory' },
      { name: 'LineFeed', value: true },
      { name: 'PrintLine', value: true },
      { name: 'LineFeed', value: true },
    ]

    for (const g of groups) {
      commands.push({ name: 'PrintComment', value: ` ---- [${g.name || 'Unknown'}] ----` })
      commands.push({ name: 'LineFeed', value: true })
      for (const r of g.rows || []) {
        commands.push({ name: 'PrintTextLine', value: `${r.name || '-'}${r.unit ? ` (${r.unit})` : ''}` })
        commands.push({ name: 'PrintTextLine', value: `     begin :  ${this.amount(r.begin)}${this.unitText(r.unit)}` })
        commands.push({ name: 'PrintTextLine', value: `     add :  ${this.amount(r.add)}${this.unitText(r.unit)}` })
        commands.push({ name: 'PrintTextLine', value: `     sold :  ${this.amount(this.soldAsNegative(r.sold))}${this.unitText(r.unit)}` })
        commands.push({ name: 'PrintTextLine', value: `     balance :  ${this.amount(r.balance)}${this.unitText(r.unit)}` })
        commands.push({ name: 'LineFeed', value: true })
      }
      commands.push({ name: 'LineFeed', value: true })
    }

    commands.push({ name: 'PrintComment', value: `stock movement : ${groups.reduce((n, g) => n + (g.rows?.length || 0), 0)} items.` })
    commands.push({ name: 'PrintComment', value: ' ' })
    commands.push({ name: 'PrintComment', value: `Print at ${longTime}` })

    return commands
  }

  private amount(value: number) {
    return useFormatNumber(Number(value || 0), 2, true)
  }

  private soldAsNegative(value: number) {
    const n = Number(value || 0)
    if (n === 0) return 0
    return n > 0 ? -n : n
  }

  private unitText(unit?: string) {
    return unit ? ` ${unit}` : ''
  }
}
